import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const InputWarningIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M8.99984 4.83268C9.46008 4.83268 9.83317 5.20578 9.83317 5.66602V9.83268C9.83317 10.2929 9.46008 10.666 8.99984 10.666C8.5396 10.666 8.1665 10.2929 8.1665 9.83268V5.66602C8.1665 5.20578 8.5396 4.83268 8.99984 4.83268Z"
          fill="#E90200"
        />
        <path
          d="M8.99984 11.4993C8.5396 11.4993 8.1665 11.8724 8.1665 12.3327C8.1665 12.7929 8.5396 13.166 8.99984 13.166C9.46008 13.166 9.83317 12.7929 9.83317 12.3327C9.83317 11.8724 9.46008 11.4993 8.99984 11.4993Z"
          fill="#E90200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666504 8.99935C0.666504 13.6017 4.39746 17.3327 8.99984 17.3327C13.6022 17.3327 17.3332 13.6017 17.3332 8.99935C17.3332 4.39698 13.6022 0.666016 8.99984 0.666016C4.39747 0.666016 0.666504 4.39698 0.666504 8.99935ZM2.33317 8.99935C2.33317 12.6812 5.31794 15.666 8.99984 15.666C12.6817 15.666 15.6665 12.6812 15.6665 8.99935C15.6665 5.31745 12.6817 2.33268 8.99984 2.33268C5.31794 2.33268 2.33317 5.31745 2.33317 8.99935Z"
          fill="#E90200"
        />
      </svg>
    );
  }
);

export default InputWarningIcon;
